import styled from "styled-components";
import { Spinner } from "@sablier/v2-components/atoms";
import { _ } from "@sablier/v2-mixins";

const Wrapper = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    justify-content: center;
    width: 100%;
    height: 200px;

    color: ${(props) => props.theme.colors.primaryMiddle};
    border-radius: 6px;
    background-color: ${(props) => props.theme.colors.dark200};
  }
`;

export default function Loader() {
  return (
    <Wrapper>
      <Spinner />
    </Wrapper>
  );
}
